module.exports = __webpack_public_path__ + "img/Villa_Borna_59.2d97beea.jpg";